import * as React from 'react'
import styles from './styles.module.css'

const clamp01 = (v: number) => Math.min(1, Math.max(0, v))
const toPercent = (v01: number) => `${Math.round(clamp01(v01) * 100)}%`

type ProgressBarProps = {
  /** 0..1 */
  progress: number
  /** transition duration for width changes */
  durationMs?: number
  easing?: string
  className?: string
  trackClassName?: string
  fillClassName?: string
}

export const ProgressBar = ({
  progress,
  durationMs = 250,
  easing = 'linear',
  className,
  trackClassName,
  fillClassName,
}: ProgressBarProps) => {
  const p = clamp01(progress)

  return (
    <div className={`${styles.track} ${trackClassName ?? ''} ${className ?? ''}`}>
      <div
        className={`${styles.fillTransition} ${fillClassName ?? ''}`}
        style={
          {
            ['--to' as any]: toPercent(p),
            ['--dur' as any]: `${durationMs}ms`,
            ['--ease' as any]: easing,
          } as React.CSSProperties
        }
      />
    </div>
  )
}
